import { initSwiper } from '../../components/swiper';

// Scoped to the container's own section — the section can be added to the
// template more than once, and an unscoped lookup could remove another
// instance's fallback.
const removeFallbackCarousel = (containerEl) => {
  const sectionEl = containerEl.closest('.shopify-section') || document;
  const fallbackEl = sectionEl.querySelector('[data-collection-recs-fallback]');
  if (fallbackEl) fallbackEl.remove();
};

const finishInjection = (containerEl) => {
  // No slides means the element returned no products — drop the empty AC
  // container and leave the Liquid-rendered fallback carousel in place.
  if (!containerEl.querySelector('.swiper-slide')) {
    containerEl.remove();
    return;
  }

  // AC ignores request args, so the section-setting heading is applied here
  // rather than in the element template (which renders its hard-coded default).
  const heading = containerEl.dataset.acsHeading;
  const headingEl = containerEl.querySelector('h2');
  if (heading && headingEl) headingEl.textContent = heading;

  removeFallbackCarousel(containerEl);
  const sliderEl = containerEl.querySelector('[data-swiper]');
  if (sliderEl) initSwiper(sliderEl);
  if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
    window.yotpoWidgetsContainer.initWidgets();
  }
};

const initCollectionRecs = () => {
  const containerEl = document.querySelector('[data-acs-collection-recs]');
  if (!containerEl) return;
  if (containerEl.dataset.recsLoaded === 'true') return;
  containerEl.dataset.recsLoaded = 'true';

  // The strategy resolves page context from page_context.page_url when
  // provided; without it, it can only fall back to the x_page_url the library
  // sends (the current location). That is the collection page here anyway, but
  // the section passes the collection URL explicitly so the context is
  // deterministic.
  const pageUrl = containerEl.dataset.acsPageUrl;
  const hasGraphene = typeof window.graphenehc?.load === 'function';
  if (!hasGraphene || !pageUrl) {
    containerEl.remove();
    return;
  }

  window.graphenehc.load({
    elements: [{ id: 'category_page_carousel', target: '[data-acs-collection-recs]' }],
    // NOTE: request `args` never reach element template renders (verified
    // 2026-07-27) — the heading is applied client-side in finishInjection.
    // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
    page_context: {
      // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
      currency_id: window.Shopify.currency.active,
      // eslint-disable-next-line camelcase -- GrapheneHC API requires snake_case keys.
      page_url: window.location.origin + pageUrl,
    },
    success: () => {
      finishInjection(containerEl);
    },
  });
};

export default initCollectionRecs;
